import { atom } from 'jotai';

export const attemptAtom = atom(0);
